export default __webpack_public_path__ + "static/media/Medina.87b70489.jpg";